import { render, staticRenderFns } from "./news-add.vue?vue&type=template&id=636d3fac&scoped=true&"
import script from "./news-add.vue?vue&type=script&lang=js&"
export * from "./news-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d3fac",
  null
  
)

export default component.exports